class Version {
    getVersion() {
        return "3.0.0";
    }
}

export default new Version();